import { qz } from "../client";
import { createNamespaceStore } from "../internal/createNamespaceStore";
import { type FileEvent, type FileState } from "./types";

const MAX_FILE_EVENTS = 100;

const parseFileEvent = (raw: unknown): FileEvent | null => {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;

  const data = raw as Record<string, unknown>;

  if (typeof data.message === "string")
    return { kind: "ERROR", message: data.message, raw };

  if (typeof data.file === "string" && typeof data.eventType === "string") {
    return {
      data: "data" in data ? data.data : undefined,
      eventType: data.eventType,
      file: data.file,
      kind: "ACTION",
      raw,
    };
  }

  return null;
};

export const fileStore = createNamespaceStore<FileState, FileEvent>({
  applyEvent: (state, event, at) => ({
    ...state,
    events: [...state.events, event].slice(-MAX_FILE_EVENTS),
    lastEventAt: at,
    // File errors arrive as events; surface them through the standard listener
    // error slot so UIs don't need a separate reducer.
    lastListenerError: event.kind === "ERROR" ? event.message : null,
  }),
  createInitialState: () => ({
    activePaths: [],
    events: [],
    lastEventAt: null,
    lastListenerError: null,
  }),
  label: "file",
  parseEvent: parseFileEvent,
  registerCallback: (handler) => qz.file.setFileCallbacks(handler),
});

export const addActiveFilePath = (path: string) => {
  fileStore.setState((s) => ({
    ...s,
    activePaths: s.activePaths.includes(path)
      ? s.activePaths
      : [...s.activePaths, path],
  }));
};

export const removeActiveFilePath = (path?: string) => {
  fileStore.setState((s) => ({
    ...s,
    activePaths: path
      ? s.activePaths.filter((activePath) => activePath !== path)
      : [],
  }));
};
